<template>
  <el-dialog 
    width="600px"
    height="600px"
    title="选择位置" 
    :visible.sync="dialogMap.isShow"
    append-to-body
    @opened='opened' >
    <el-form ref="form" :model="form" label-width="80px">        
      <el-form @submit.native.prevent>     
        <el-form-item >
          <el-input ref="keyword" v-model="keyword" placeholder="请输入地址"></el-input>
        </el-form-item>
      </el-form>
      <baidu-map 
        class="map" 
        :center="postionMap" 
        :zoom="12.8" 
        :scroll-wheel-zoom="true"
      >
        <bm-marker  
          :position="postionMap" 
          :dragging="true" 
          @dragend="getDragendpostion"
        >    
        </bm-marker>
        <bm-local-search 
          :keyword="keyword" 
          :panel="false" 
          :auto-viewport="true" 
          @searchcomplete="searchcomplete" 
        >
        </bm-local-search>
      </baidu-map>      
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogMap.isShow = false">取 消</el-button>
      <el-button type="primary" @click="SavePoint">保 存</el-button>
    </div> 
  </el-dialog> 
</template>

<script  type='text/ecmascript-6'>
export default {
  props:{
    dialogMap:{}
  },
  data (){
    return {
      keyword:'',
      form : {},
      dialogStore:{
        isShow:false
      },
      postionMap:{  //地图坐标
        lng: 116.331398,
        lat: 39.897445
      },
    }
  },  
  components:{    
  },
  computed:{
  },
  mounted(){
  },
  methods:{
    getDragendpostion(marker){
      debugger
      this.postionMap = marker.Ag
    }, 
    searchcomplete(result){
      if(result !=undefined)
        this.postionMap = result.Hr[0].point
    },
    opened:function(){      
      if(this.dialogMap.oldPoint.lat !=0)
        this.postionMap = this.dialogMap.oldPoint      
      this.$refs.keyword.focus()
    },    
    SavePoint(){
      this.$emit('UpdatePostion',this.postionMap)
      this.dialogMap.isShow = false
    }
  },
  created(){
  
  },
}
</script>